<ng-container *ngIf="user">
  <h4><p class="text-center">Settings</p></h4>

  <div class="card">
    <div class="card-block">
      <pre *ngIf="error">{{error}}</pre>
      <div class="form-group row">
        <label class="col-form-label col-3">Nieuw wachtwoord</label>
        <div class="col-9"><input class="form-control" [(ngModel)]="password" type="text"></div>
      </div>

      <div class="form-group row">
        <label class="col-form-label col-3">Nieuw wachtwoord herhaling</label>
        <div class="col-9"><input class="form-control" [(ngModel)]="passwordRepeat" type="text"></div>
      </div>
    </div>
  </div>

  <div class="row ui-toolbar">
    <div class="col-md-6">
      <button type="button" class="btn btn-primary" (click)="saveUser()">
        Opslaan
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
        Annuleren
      </button>
    </div>
  </div>
</ng-container>



// WEBPACK FOOTER //
// ./src/app/pages/settings/settings.component.html